import { render, staticRenderFns } from "./LongTermDisability.vue?vue&type=template&id=82e35e8c&"
import script from "./LongTermDisability.vue?vue&type=script&lang=js&"
export * from "./LongTermDisability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports